import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Box, Stack } from "@mui/material";
import {
  ISampleTableData,
  FacilityListProps,
} from "../../../type/componentsType/TkFacilityTableChanger";
import { changeArrOrder } from "../../../utils/TkFacilityTableChangeArrOrder";
import { TkTable } from "../../atoms/TkTable";
import "./_style.scss";
import { useEffect, useState } from "react";
import { changeAmountFormat } from "../../../utils/useTools";
export type itemType = keyof ISampleTableData;

/**
 * 一覧表入れ替え部品
 * テーブルの表示順を入れ替える
 * @return TkFacilityTableChanger 一覧表入れ替え部品
 */
export const TkFacilityTableChanger: React.FC<
  ISampleTableData & FacilityListProps
> = ({ facilityList, headList, onClick }) => {
  const [tableDataMoveByClick, setTableDataMoveByClick] = useState<any>();
  const iconHeight = "15px";

  let bodyinput: any = facilityList?.map((item) => {
    let is: any = [
      {
        id: item.id,
      },
      {
        children: (
          <>
            <Stack
              direction={"column"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Box
                sx={{ height: iconHeight }}
                data-testid="tkFTupForTest"
                onClick={() => {
                  let res = changeArrOrder(bodyinput, item.id, "up");
                  setTableDataMoveByClick([...(res as any)]);
                  onClick && onClick(res);
                }}
              >
                <ArrowDropUpIcon sx={{ cursor: "pointer" }}></ArrowDropUpIcon>
              </Box>

              <Box
                sx={{ height: iconHeight, marginBottom: "10px" }}
                data-testid="tkFTDownForTest"
                onClick={() => {
                  let res = changeArrOrder(bodyinput, item.id, "down");
                  setTableDataMoveByClick([...(res as any)]);
                  onClick && onClick(res);
                }}
              >
                <ArrowDropDownIcon
                  sx={{ cursor: "pointer" }}
                ></ArrowDropDownIcon>
              </Box>
            </Stack>
          </>
        ),
        className: "tkFaciltyTableChangerItem",
        verticalAlign: "middle",
        width: 100,
      },
      {
        children: item.No + ":" + item.FName,
        className: "tkFaciltyTableChangerItem",
        width: 400,
      },
      {
        children: item.FType,
        className: "tkFaciltyTableChangerItem",
        width: 150,
      },
      {
        children: changeAmountFormat(item.allApplicationPerson ?? 0),
        className: "tkFaciltyTableChangerItem",
        width: 180,
        align: "right",
      },
      {
        children: changeAmountFormat(item.joinStaffNum ?? 0),
        className: "tkFaciltyTableChangerItem",
        width: 150,
        align: "right",
      },
      {
        children: changeAmountFormat(item.yearJoindisableStaffNum ?? 0),
        className: "tkFaciltyTableChangerItem",
        width: 150,
        align: "right",
      },
      {
        children: changeAmountFormat(item.timeJoindisableStaffNum ?? 0),
        className: "tkFaciltyTableChangerItem",
        width: 150,
        align: "right",
      },
      {
        children: item.staffRegistrationStatus,
        className: "tkFaciltyTableChangerItem",
        width: 110,
      },
      {
        children: item.facilityInfoModify,
        className: "tkFaciltyTableChangerItem",
        width: 170,
      },
      {
        children: item.stuffInfoRegistration,
        className: "tkFaciltyTableChangerItem",
        width: 170,
      },
    ];
    return is;
  });

  useEffect(() => {
    bodyinput && setTableDataMoveByClick(bodyinput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityList]);

  return (
    <>
      <TkTable bodyList={tableDataMoveByClick} headList={headList} />
    </>
  );
};
export default TkFacilityTableChanger;
